
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { MessageSquare, Coins, ArrowRight, Gift, Users, Shield, Star } from "lucide-react";

const GetInvolvedBanner = () => {
  return (
    <section className="py-8 bg-gradient-to-br from-amber-400/10 via-orange-500/10 to-amber-600/5 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5 bg-[url('/img/nationcard-hero1.png')] bg-cover bg-center"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-amber-400 via-orange-500 to-amber-600 rounded-xl p-6 md:p-8 shadow-xl relative overflow-hidden">
            {/* Background overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-amber-400/95 via-orange-500/90 to-amber-600/95"></div>
            
            <div className="relative z-10">
              <div className="flex flex-col lg:flex-row items-center gap-6">
                {/* Badge */}
                <div className="w-full lg:w-auto flex justify-center lg:justify-start">
                  <Badge
                    variant="outline"
                    className="bg-white/15 text-white border-white/30 px-3 py-1 text-xs backdrop-blur-sm"
                  >
                    <Gift size={14} className="mr-1" />
                    <span>Earn Rewards</span>
                  </Badge>
                </div>
              </div>

              <div className="flex flex-col lg:flex-row items-center gap-6 mt-4">
                {/* Icons */}
                <div className="flex items-center gap-2 flex-shrink-0">
                  <div className="bg-white/20 p-2 rounded-full backdrop-blur-sm border border-white/30">
                    <MessageSquare className="h-5 w-5 text-white" />
                  </div>
                  <div className="bg-white/20 p-2 rounded-full backdrop-blur-sm border border-white/30">
                    <Coins className="h-5 w-5 text-white" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 text-center lg:text-left text-white">
                  <h2 className="text-xl md:text-2xl font-bold mb-2 leading-tight">
                    Want to Shape the{" "}
                    <span className="text-yellow-200">Conversation?</span>
                  </h2>
                  <p className="text-sm md:text-base opacity-90 mb-2 leading-relaxed">
                    Join our community of Verified Pollsters—earn points for surveys and redeem rewards.
                  </p>
                </div>

                {/* CTA */}
                <div className="flex-shrink-0">
                  <Button
                    size="default"
                    asChild
                    className="px-6 py-2 bg-white hover:bg-gray-100 text-amber-600 hover:text-amber-700 font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300"
                  >
                    <Link to="/solutions/verified-pollsters">
                      Get Involved
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Link>
                  </Button>
                </div>
              </div>

              {/* Trust Indicators */}
              <div className="flex flex-wrap justify-center lg:justify-start items-center gap-4 mt-4 text-xs text-white/80">
                <div className="flex items-center gap-1">
                  <Users size={12} />
                  <span>124k+ Pollsters</span>
                </div>
                <div className="flex items-center gap-1">
                  <Shield size={12} />
                  <span>Verified Citizens</span>
                </div>
                <div className="flex items-center gap-1">
                  <Star size={12} />
                  <span>Real Rewards</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetInvolvedBanner;
